import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const ParagraphStyle = styled.p.attrs(
  ({ $color, $backgroundColor, $align, $fontSize, $textTransform }) => ({
    $color: $color || "",
    $backgroundColor: $backgroundColor || "",
    $fontSize: $fontSize || undefined,
    $align: $align || "",
    $textTransform: $textTransform || "",
  })
)`
  color: ${({ $color }) => $color};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  font-size: ${({ $fontSize }) => $fontSize};
  text-align: ${({ $align }) => $align};
  text-transform: ${({ $textTransform }) => $textTransform};
`;

const Paragraph = ({
  color,
  backgroundColor,
  content,
  align,
  fontSize,
  anchor,
  className,
  direction,
  textTransform,
  innerStyle,
}) => {
  return (
    <ParagraphStyle
      id={anchor}
      className={className}
      dir={direction || "auto"}
      $color={color}
      $backgroundColor={backgroundColor}
      $fontSize={fontSize}
      $align={align}
      $textTransform={textTransform}
      dangerouslySetInnerHTML={{ __html: content }}
      style={innerStyle}
    />
  );
};

Paragraph.propTypes = {
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  anchor: PropTypes.string,
  className: PropTypes.string,
  fontSize: PropTypes.string,
  align: PropTypes.string,
  direction: PropTypes.string,
  textTransform: PropTypes.string,
  innerStyle: PropTypes.object,
};

export default Paragraph;
